export const PAYMENT_METHODS = {
    CARD: 'CARD',
    CASH: 'CASH',
    NONE: 'NONE',
    BILLING_CARD: 'BILLING_CARD',
    BILLING_TRANSFER: 'BILLING_TRANSFER',
    TERMINAL: 'TERMINAL',
};
